export const getEstadoIdByName = (state) => (nombreEstado) => {
    const estado = state.estados.find(e => e.estado === nombreEstado);
    return estado ? estado.id : null;
};

export const getEstadoByName = (state) => (nombreEstado) => {
    return state.estados.find(e => e.estado === nombreEstado);
};

export const getEstadoById = (state) => (id) => {
    return state.estados.find(e => e.id === id);
};

/**
 * Retorna un objeto con los nombres de estados como keys y sus IDs como values
 * Útil para acceso directo: ESTADO_IDS.PENDIENTE
 * @returns {Object} - { PENDIENTE: 4, CONFIRMADA: 3, ... }
 */
export const ESTADO_IDS = (state) => {
    return state.estados.reduce((acc, estado) => {
        acc[estado.estado] = estado.id;
        return acc;
    }, {});
};

export const existeEstado = (state) => (nombreEstado) => {
    return state.estados.some(e => e.estado === nombreEstado);
};

export const getEstadoIdEnProceso = (state) => {
    return state.estados.find(e => e.estado === 'EN PROCESO').id;
};

export const getEstadoIdPresupuestada = (state) => {
    return state.estados.find(e => e.estado === 'PRESUPUESTADA').id;
};

export const getEstadoIdConfirmada = (state) => {
    return state.estados.find(e => e.estado === 'CONFIRMADA').id;
};

export const getEstadoIdConfirmacionFinal = (state) => {
    return state.estados.find(e => e.estado === 'CONFIRMACION FINAL').id;
};

